import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: "relative",
    overflow: "hidden",
    backgroundColor: "black",
  },
  media: {
    flex: 1,
  },
  webVideo: {
    ...StyleSheet.absoluteFillObject,
    width: "100%",
    height: "100%",
    backgroundColor: "black",
    objectFit: "contain",
  } as any,
  touchLayer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 998,
  },
  advertisementBadge: {
    position: "absolute",
    zIndex: 1003,
    top: 14,
    right: 14,
    minHeight: 30,
    paddingHorizontal: 11,
    borderRadius: 16,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    borderWidth: 1,
    borderColor: "rgba(255,188,147,.82)",
    backgroundColor: "rgba(174,73,47,.94)",
  },
  advertisementBadgeText: {
    color: "#fff4dd",
    fontSize: 12,
    fontWeight: "900",
  },
  playbackBrandBadge: {
    position: "absolute",
    zIndex: 1002,
    top: 12,
    left: 12,
    width: 194,
    height: 60,
  },
  playbackBrandBadgePressed: {
    opacity: 0.76,
    transform: [{ scale: 0.98 }],
  },
  playbackBrandLogo: {
    width: 194,
    height: 60,
  },
  downloadModalBackdrop: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 18,
    backgroundColor: "rgba(0,0,0,0.78)",
  },
  downloadModalCloseArea: {
    ...StyleSheet.absoluteFillObject,
  },
  downloadModalCard: {
    width: "100%",
    maxWidth: 390,
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
    borderRadius: 20,
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#80643b",
    backgroundColor: "#151515",
  },
  downloadModalTitle: {
    color: "#f5efe5",
    fontSize: 21,
    fontWeight: "800",
  },
  downloadModalSubtitle: {
    marginTop: 7,
    color: "#aaa49b",
    fontSize: 14,
  },
  downloadModalQr: {
    width: 210,
    height: 210,
    marginTop: 18,
    marginBottom: 16,
    borderRadius: 14,
    backgroundColor: "white",
  },
  downloadModalActions: {
    width: "100%",
    flexDirection: "row",
    gap: 10,
  },
  downloadModalButton: {
    flex: 1,
    height: 46,
    borderRadius: 23,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 7,
  },
  downloadModalButtonAndroid: {
    backgroundColor: "#d7a955",
  },
  downloadModalButtonIos: {
    backgroundColor: "#27231e",
    borderWidth: 1,
    borderColor: "#80643b",
  },
  downloadModalButtonPrimaryText: {
    color: "#17120b",
    fontSize: 14,
    fontWeight: "800",
  },
  downloadModalButtonSecondaryText: {
    color: "#f5efe5",
    fontSize: 14,
    fontWeight: "800",
  },
  downloadModalCloseButton: {
    marginTop: 10,
    paddingHorizontal: 14,
    paddingVertical: 8,
  },
  downloadModalCloseText: {
    color: "#aaa49b",
    fontSize: 14,
  },
  playbackInfoBadge: {
    position: "absolute",
    zIndex: 1002,
    top: 90,
    left: 12,
    right: 100,
    paddingHorizontal: 9,
    paddingVertical: 6,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "rgba(215,169,85,0.42)",
    backgroundColor: "rgba(5,5,5,0.68)",
  },
  playbackInfoBadgeBelowStrategy: {
    top: 128,
  },
  playbackInfoRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  playbackInfoVersion: {
    flexShrink: 1,
    color: "rgba(255,255,255,0.78)",
    fontSize: 10,
    lineHeight: 13,
    fontWeight: "700",
  },
  playbackInfoSource: {
    flexShrink: 1,
    color: "white",
    fontSize: 11,
    lineHeight: 15,
    fontWeight: "600",
  },
  playbackInfoNetwork: {
    flexShrink: 1,
    color: "rgba(255,255,255,0.78)",
    fontSize: 9,
    lineHeight: 12,
    marginTop: 1,
  },
  mediaLoadingContainer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 1000,
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "box-none",
  },
  mediaLoadingCard: {
    width: "76%",
    maxWidth: 340,
    paddingHorizontal: 18,
    paddingVertical: 15,
    borderRadius: 14,
    backgroundColor: "rgba(255,255,255,0.18)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.58)",
    alignItems: "center",
    backdropFilter: "blur(9px)",
    WebkitBackdropFilter: "blur(9px)",
  },
  mediaLoadingPercent: {
    color: "white",
    fontSize: 20,
    fontWeight: "800",
    marginBottom: 9,
  },
  mediaLoadingTrack: {
    width: "100%",
    height: 6,
    overflow: "hidden",
    borderRadius: 999,
    backgroundColor: "rgba(255,255,255,0.3)",
  },
  mediaLoadingFill: {
    height: "100%",
    borderRadius: 999,
    backgroundColor: "white",
  },
  mediaLoadingText: {
    marginTop: 9,
    color: "rgba(255,255,255,0.9)",
    fontSize: 13,
    lineHeight: 19,
    textAlign: "center",
  },
  mediaRetryButton: {
    minHeight: 36,
    marginTop: 11,
    paddingHorizontal: 14,
    paddingVertical: 7,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.8)",
    backgroundColor: "rgba(255,255,255,0.18)",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  mediaRetryText: {
    color: "white",
    fontSize: 13,
    fontWeight: "700",
  },
  audioUnlockContainer: {
    position: "absolute",
    zIndex: 1001,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  audioUnlockButton: {
    minHeight: 44,
    paddingHorizontal: 18,
    paddingVertical: 10,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.55)",
    backgroundColor: "rgba(20,20,20,0.82)",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  audioUnlockButtonFailed: {
    backgroundColor: "rgba(150,35,35,0.9)",
  },
  audioUnlockText: {
    color: "white",
    fontSize: 15,
    fontWeight: "700",
  },
});
export default styles;
